import { render, staticRenderFns } from "./df-page-club-card.vue?vue&type=template&id=1e5f3d7a"
import script from "./df-page-club-card.ts?vue&type=script&lang=js&external"
export * from "./df-page-club-card.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports